import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND } from "@/data/site";
import { cn } from "@/lib/utils";

interface CTAGroupProps {
  className?: string;
  variant?: "default" | "onDark";
  primaryLabel?: string;
}

export function CTAGroup({ className, variant = "default", primaryLabel = "Get Free Estimate" }: CTAGroupProps) {
  const onDark = variant === "onDark";
  return (
    <div className={cn("flex flex-col sm:flex-row gap-3", className)}>
      <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-gold font-semibold">
        <Link to="/contact">
          {primaryLabel} <ArrowRight className="ml-1 h-4 w-4" />
        </Link>
      </Button>
      <Button
        asChild
        size="lg"
        variant="outline"
        className={cn(
          "font-semibold",
          onDark ? "bg-transparent border-background/40 text-background hover:bg-background hover:text-foreground" : ""
        )}
      >
        <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`}>
          <Phone className="mr-1 h-4 w-4" /> Call {BRAND.phoneDisplay}
        </a>
      </Button>
    </div>
  );
}
